import { Button, Dropdown, Icon, MenuInfo, Text, theme } from "@findemdev/maui";
import { useCallback } from "react";
import { Actions, Container } from "./RowCell.styled";
import { CompanyListsTableColumnKeysType } from "../util/common";
import { ICompanyList } from "../../../../types/common";
import { IGetCompanyLogosResponseDataObj } from "../../../../../../types/pub";
import CompanyLogo from "../../../../../Common/CompanyLogo/CompanyLogo";
import useIsCompanyListOwner from "../../../../hooks/useIsCompanyListOwner";
import ShareWithOrgToggle from "../../ShareWithOrgToggle/ShareWithOrgToggle";

interface IRowCellProps {
  col: CompanyListsTableColumnKeysType;
  value: string | string[] | null;
  originalValue: ICompanyList;
  companyDetailsByMetaRef: Record<string, IGetCompanyLogosResponseDataObj | undefined>;
  shortlistedCompanyMetaRefs: string[] | undefined;
  handleShowBuildCustomListDetails: ((companyList: ICompanyList) => void) | undefined;
  handleCompanyListDelete: ((companyList: ICompanyList) => void) | undefined;
};

const RowCell = ({
  col,
  value,
  originalValue,
  companyDetailsByMetaRef,
  shortlistedCompanyMetaRefs,
  handleShowBuildCustomListDetails,
  handleCompanyListDelete,
}: IRowCellProps) => {

  const handleActionsClick = useCallback((info: MenuInfo) => {
    if (info.key === 'custom_lists') {
      if (!handleShowBuildCustomListDetails) {
        return;
      }
      handleShowBuildCustomListDetails(originalValue);
    } else if (info.key === 'delete') {
      if (!handleCompanyListDelete) {
        return;
      }
      handleCompanyListDelete(originalValue);
    }
  }, [originalValue, handleShowBuildCustomListDetails, handleCompanyListDelete]);

  const handleUseInOtherApps = () => {
    if (!handleShowBuildCustomListDetails) {
      return;
    }
    handleShowBuildCustomListDetails(originalValue);
  }

  const isOwner = useIsCompanyListOwner(originalValue);

  return <Container>
    {col === 'sharedWithOrg' ? (
        <ShareWithOrgToggle companyList={originalValue} />
    ) :
      col === 'savedCompanies' ? shortlistedCompanyMetaRefs?.length ?
        <div style={{
          display: "flex",
          alignItems: "center",
        }}>
          {shortlistedCompanyMetaRefs.slice(0, 5).map((metaRef, index) => {
            const companyObj = companyDetailsByMetaRef[metaRef];

            return (<div key={metaRef} style={{
              marginRight: "-5px",
              zIndex: index + 1,
              position: 'relative',
            }}>
              <CompanyLogo
                link={undefined}
                companyName={companyObj?.company?.company_name}
                height="24px" width="24px"
                companyLogos={companyObj?.company?.logos}
              />
            </div>)
          }
          )}
          {shortlistedCompanyMetaRefs.length > 5 && (
            <div
              style={{
                marginRight: "-5px",
                zIndex: "7",
                position: 'relative',
                height: "24px",
                width: "24px",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                border: `1px solid ${theme.colors['grey-300']}`,
                borderRadius: "50%",
                justifyContent: "center"
              }}
            >
              <Icon icon="more_horiz" $color={theme.colors['grey-500']} />
            </div>
          )}
          <div style={{
            zIndex: "8",
            position: 'relative',
            paddingLeft: '10px',
            color: theme.colors['grey-600'],
          }}>{`${shortlistedCompanyMetaRefs.length} Compan${shortlistedCompanyMetaRefs.length > 1 ? "ies" : "y"}`}</div>
        </div>
        : <div style={{ color: theme.colors['grey-500'] }}>
          No saved companies yet
        </div> :
        col === 'actions' ? <Actions>
          <Button
            icon={<Icon icon="copy" />}
            size="middle"
            type="default"
            onClick={handleUseInOtherApps}
          >
            Use in Other Apps
          </Button>
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [{
                key: 'delete',
                label: 'Delete',
                disabled: !isOwner,
                title: !isOwner ? "Only the owner can delete this list" : undefined,
              }],
              onClick: handleActionsClick,
            }}
          >
            <div>
              <Icon icon="more_horiz" />
            </div>
          </Dropdown>
        </Actions> :
          col === 'lastEdited' ? <div style={{ color: theme.colors['grey-500'] }}>{value}</div> :
            <Text variant="mediumSpecialHeader" style={{
              textTransform: "none"
            }}>{value}</Text>}
  </Container>
};

export default RowCell;